import { useState } from 'react';

const StockRangeSwitcher = (props) => {
	const [range, setRange] = useState('Daily');

	const activeClass =
		'inline-flex items-center gap-x-1.5 py-1.5 px-2 rounded-full text-xs font-medium border border-red-500 text-red-500 border border-red-500 text-red-500 font-semibold';
	const defaultClass =
		'inline-flex items-center gap-x-1.5 py-1.5 px-2 rounded-full text-xs font-medium border border-gray-800 text-gray-800 dark:border-gray-200 dark:text-white';

	const changeRange = (value: string) => {
		setRange(value);
		document.dispatchEvent(new CustomEvent('GraphRangeChanged', { detail: { range: value } }));
	};
	return (
		<div className="flex align-middle justify-center gap-x-2 p-2">
			<button
				onClick={() => changeRange('Hourly')}
				className="ql-bold w-auto h-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
				type="button"
			>
				<span className={range === 'Hourly' ? activeClass : defaultClass}>Hourly</span>
			</button>
			<button
				onClick={() => changeRange('Daily')}
				className="ql-bold w-auto h-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
				type="button"
			>
				<span className={range === 'Daily' ? activeClass : defaultClass}>Daily</span>
			</button>
			<button
				onClick={() => changeRange('Weekly')}
				className="ql-bold w-auto h-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
				type="button"
			>
				<span className={range === 'Weekly' ? activeClass : defaultClass}>Weekly</span>
			</button>
			<button
				onClick={() => changeRange('Monthly')}
				className="ql-bold w-auto h-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
				type="button"
			>
				<span className={range === 'Monthly' ? activeClass : defaultClass}>Monthly</span>
			</button>
			<button
				onClick={() => changeRange('Quarterly')}
				className="ql-bold w-auto h-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
				type="button"
			>
				<span className={range === 'Quarterly' ? activeClass : defaultClass}>Quarterly</span>
			</button>
		</div>
	);
};

export default StockRangeSwitcher;
